import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const historyLogService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/history-log/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/history-log/' + id)
      return response.data
    },
    countPinned: async () => {
      const response = await axiosInstance.get('/history-log/count-pinned')
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/history-log', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/history-log/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/history-log/${id}`)
      return response.data
    },
}